exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".error {\n  color: red;\n}\n.el-popover {\n  color: black;\n}\n.preview {\n  border-style: dotted;\n  border-width: 1px;\n  padding: 10px;\n}", ""]);

// exports
